<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            Sensoreigenschaften ändern
        </template>
        
        <div v-visible="loading" class="progress progress-sm mb-0 mt-0">
            <div class="progress-bar progress-bar-indeterminate bg-blue"></div>
        </div>
        
        <transition name="fade" @after-enter="$refs.sensorLabel.focus()">
        <div class="row mt-3 mb-2" >
            <div class="col-12">
                <label class="form-label">Sensorbezeichnung</label>
                <input ref="sensorLabel" type="text" v-model="sensorLabel" class="form-control" name="example-text-input" placeholder="Name des Sensors">
            </div>           
        </div>
        </transition>
        
        <Alert type="danger" :show="alert.emptySensorLabel" :timeout="5000">
            <template v-slot:title>Sensorbezeichnung fehlt</template>
            Bitte geben Sie einen aussagekräftigen Namen für die Sensorbezeichnung in der App an. 
        </Alert>
        
        <ShareSensor v-if="true" v-model:sharedUserIds="sharedUserIds" v-model:loading="loading"></ShareSensor>
        
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Datenimport in die Bewässerungs-App</label>
                <ButtonCheckBox v-model:checked="sensorImportActive" >
                    <template v-slot:isChecked>Datenimport aktiviert</template>
                    Datenimport aktivieren
                </ButtonCheckBox>
            </div>           
        </div>
        
        <Alert type="danger" :show="alert.disableSensorImport" :timeout="12000">
            <template v-slot:title>Datenimport deaktiviert</template>
            Die Daten des Sensor werden momentan von anderen Nutzern mit verwendet. Wenn Sie den Datenimport
            deaktivieren, kann dies Auswirkungen auf Schläge dieser Nutzer haben. Die Nutzer werden über die
            Deaktivierung per E-Mail informiert.
        </Alert>
        
        <template v-slot:footer>
            <button class="btn btn-light link-secondary" @click="closeModal" >
                Abbrechen
            </button>
            <button class="btn ms-auto btn-info" @click="submit">
               <!-- <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg> -->
                    Sensor ändern
            </button>
        </template>
    </Modal>
</template>

<script>
import axios from 'axios';
import * as dayjs from 'dayjs';

import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';
import ShareSensor from '@/components/sensor/ShareSensor.vue';
import ButtonCheckBox from '@/components/input/ButtonCheckBox.vue';

export default {
    name: 'New Sensor Modal',
    components: {
        Modal,
        Alert,
        ShareSensor,
        ButtonCheckBox
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        sensor: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            sensorId: null,
            sensorLabel: '',
            sharedUserIds: [],
            sensorImportActive: null,
            loading: false,
            show: {
               
            },
            alert: {
                emptySensorLabel: false,
                disableSensorImport: false
            }        
        }
    },
    computed: {
       
    },
    methods: {
        submit: function () {
            if (this.validateForm()) {
                this.$emit('alterSensor', {
                    sensorId: this.sensorId,
                    label: this.sensorLabel,
                    sharedUserIds: this.sharedUserIds,
                    isImportActive: this.sensorImportActive
                });
                this.$nextTick(function() { 
                    this.closeModal();
                });     
            }
        },
        openModal: function () {
            this.sensorId = this.sensor.id;
            this.sensorLabel = this.sensor.label;
            this.sharedUserIds = this.sensor.sharedUserIds;
            this.sensorImportActive = this.sensor.isImportActive;
        
            this.$refs.modal.openModal();            
        },
        closeModal: function () {
            this.$refs.modal.closeModal();            
        },
        validateForm: function () {
           const self = this;
           self.alert.emptySensorLabel = false;
            
           if ( String(self.sensorLabel).trim() === '' ) {
                self.$nextTick(function() { 
                    self.alert.emptySensorLabel = true;
                });
                return false;
           }
                       
           return true;
        }
    },
    watch: {
        sensorImportActive: function(new_value, old_value) {
            if (old_value === true && new_value === false && this.sharedUserIds.length > 0) {
                this.alert.disableSensorImport = true;
            } else {
                this.alert.disableSensorImport = false;
            }
        }
    },
    created: function() {
        
    },
    mounted: function() {
        
    }
}
</script>

